module.exports = __webpack_public_path__ + "img/ev.6f283f3a.png";